module.exports = __webpack_public_path__ + "img/gt.58255a59.svg";